/*******************************************************************************
 * @ngdoc    object
 * @name     csm.books.data.BooksData.rws.type:OptionValue
 * @constructor
 * @param {object=} option  Option info from server
 * @description
 * Product option value/price change info.
 *******************************************************************************/
/* @ngInject */ export function RunOptionValue(BooksData) {
  BooksData.rws.OptionValue = function (value) {
    return Object.assign(
      Object.create(BooksData.rws.OptionValue.prototype),
      value || {}
    );
  };

  BooksData.rws.OptionValue.prototype = {
    value: null, // Option value.
    priceChange: NaN // Product price adjustment.
  };
}
